import { ExternalCompanyHoldingsActionTypes } from "models/actionTypes/externalCompanyHoldingsActionTypes";
import { ReduxConstants } from "utils/constants";

export const externalCompanyHoldingsApproved = (id: string | number): ExternalCompanyHoldingsActionTypes => {
  return {
    type: ReduxConstants.ExternalCompanyHoldingsActions.EXTERNAL_COMPANY_HOLDINGS_APPROVED,
    payload: id,
  };
};

export const externalCompanyHoldingsSnoozed = (id: string | number): ExternalCompanyHoldingsActionTypes => {
  return {
    type: ReduxConstants.ExternalCompanyHoldingsActions.EXTERNAL_COMPANY_HOLDINGS_SNOOZED,
    payload: id,
  };
};
